import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { Marquee } from "./ui";

const stats = [
  { value: "06", label: "Engineering domains" },
  { value: "03", label: "Engagement models" },
  { value: "US + India", label: "Delivery footprint" },
  { value: "1", label: "Accountable team" },
];

const keywords = [
  "RTL design", "Micro-architecture", "UVM", "Formal / ABV", "Coverage closure", "Scan / ATPG",
  "MBIST", "Synthesis", "Floorplan", "Timing closure", "Physical verification", "Signoff",
  "FPGA prototyping", "Emulation", "Silicon bring-up", "Characterization", "Firmware", "Drivers & BSP",
];

export default function Hero() {
  return (
    <section className="on-dark noise relative overflow-hidden bg-navy-950 text-white">
      {/* Photography in a unified navy/blue treatment */}
      <img
        src="/hero-engineering.jpg"
        alt=""
        width="1600"
        height="900"
        fetchPriority="high"
        className="absolute inset-0 h-full w-full object-cover object-right opacity-60 [filter:grayscale(1)_contrast(1.1)]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/85 to-brand/25 mix-blend-normal" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-transparent to-navy-950/60" aria-hidden="true" />
      <div className="bg-grid-dark absolute inset-0 [mask-image:radial-gradient(ellipse_at_20%_30%,black,transparent_65%)]" aria-hidden="true" />
      <div className="glow-blue absolute -left-40 top-0 h-[40rem] w-[40rem] animate-drift opacity-50" aria-hidden="true" />

      <div className="container-x relative flex min-h-[100svh] flex-col justify-end pb-0 pt-28 md:pt-36">
        <div className="max-w-5xl pb-16 md:pb-24">
          <p className="eyebrow mb-8 flex items-center gap-3">
            <span className="relative flex h-2 w-2" aria-hidden="true">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-signal opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-signal" />
            </span>
            Semiconductor engineering · Senior-led execution
          </p>
          <h1 className="h-mega">
            Engineering intelligence for the <span className="text-gradient">technology stack.</span>
          </h1>
          <p className="lede mt-8 max-w-2xl">
            Senior-led semiconductor teams across RTL, verification, DFT, physical design, STA and
            silicon validation—engaged through a defined SOW, specialist augmentation or BOT.
          </p>
          <div className="mt-11 flex flex-col gap-3 sm:flex-row">
            <Link to="/contact" className="btn-primary group px-8 py-4 text-base">
              Discuss your program
              <HiArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </Link>
            <Link to="/services" className="btn-outline-dark px-8 py-4 text-base">See our capabilities</Link>
          </div>
        </div>

        {/* Factual structure, not performance claims */}
        <dl className="grid grid-cols-2 border-t border-white/10 backdrop-blur-sm md:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`flex flex-col px-2 py-7 md:px-8 ${i % 2 === 1 ? "border-l border-white/10" : ""} ${i >= 2 ? "border-t border-white/10 md:border-t-0" : ""} ${i > 0 ? "md:border-l md:border-white/10" : ""} ${i === 0 ? "md:pl-0" : ""}`}
            >
              <dt className="order-2 mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">{s.label}</dt>
              <dd className="font-display text-3xl font-semibold tracking-tight text-white md:text-4xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-white/10 bg-navy-950/80 py-5 backdrop-blur">
        <Marquee items={keywords} />
      </div>
    </section>
  );
}
